import { render, staticRenderFns } from "./MoleculeExtraSidebarComponents.vue?vue&type=template&id=3c8505fe&"
import script from "./MoleculeExtraSidebarComponents.vue?vue&type=script&lang=js&"
export * from "./MoleculeExtraSidebarComponents.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeExtraSidebarComponents.vue?vue&type=style&index=0&id=3c8505fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeExtraSidebarComponents.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FbuildingV2%2FMoleculeExtraSidebarComponents.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomSimpleButton: require('/app/components/atoms/common/AtomSimpleButton.vue').default,MoleculesProjectBuildingV2MoleculeChoosePhases: require('/app/components/molecules/project/buildingV2/MoleculeChoosePhases.vue').default,MoleculesProjectBuildingV2MoleculeChooseViewBuildings: require('/app/components/molecules/project/buildingV2/MoleculeChooseViewBuildings.vue').default,AtomsCommonAtomSquare: require('/app/components/atoms/common/AtomSquare.vue').default})
